import { createSlice } from '@reduxjs/toolkit';

const networkSlice = createSlice({
  name: 'network',
  initialState: {
    selectedNode: null,
    selectedEdge: null,
    highlightedNodes: [],
    highlightedEdges: [],
    physics: false,
    selfReference: true,
  },
  reducers: {
    setSelectedNode: (state, action) => {
      state.selectedNode = action.payload;
    },
    setSelectedEdge: (state, action) => {
      state.selectedEdge = action.payload;
    },
    setHighlightedNodes: (state, action) => {
      state.highlightedNodes = action.payload;
    },
    setHighlightedEdges: (state, action) => {
      state.highlightedEdges = action.payload;
    },
    setPhysics: (state, action) => {
      state.physics = action.payload;
    },
    setSelfReference: (state, action) => {
      state.selfReference = action.payload;
    },
  },
});

export const {
  setSelectedNode,
  setSelectedEdge,
  setHighlightedNodes,
  setHighlightedEdges,
  setPhysics,
  setSelfReference,
} = networkSlice.actions;
export default networkSlice.reducer;
